import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { injectIntl } from 'components';

import HarvestListPrint from './HarvestListPrint';
import GroupedListPrint from './GroupedListPrint';
import LabelPrint from './LabelPrint';
import PackListPrint from './PackListPrint';
import WarehouseListPrint from './WarehouseListPrint';
import SalesOrdersPrint from './SalesOrdersPrint';
import { FILTER } from '../constants';

class DropDownPrint extends Component {
  static propTypes = {
    deliveryDate: PropTypes.string.isRequired,
    info: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
    isPack: PropTypes.bool,
    pickpackRequesting: PropTypes.bool,
    requesting: PropTypes.bool,
    type: PropTypes.string.isRequired,

    formatMessage: PropTypes.func.isRequired,
  };

  static defaultProps = {
    info: [],
    isPack: false,
    pickpackRequesting: false,
    requesting: false,
  };

  render() {
    const {
      deliveryDate,
      info,
      isPack,
      isPick,
      pickpackRequesting,
      requesting,
      type,
      formatMessage,
      orders,
      printHeaderChecked,
      checkUpdated,
      currentSize,
    } = this.props;

    let renderData = null;
    switch (type) {
      case FILTER.SALES_INVOICES:
        renderData = (
          <SalesOrdersPrint
            deliveryDate={deliveryDate}
            formatMessage={formatMessage}
            info={info}
            loading={requesting}
            orders={orders}
          />
        );
        break;
      case FILTER.LABELS:
        renderData = (
          <LabelPrint
            formatMessage={formatMessage}
            info={info}
            loading={requesting}
            currentSize={currentSize}
          />
        );
        break;
      case FILTER.PICK_PACK:
        renderData = (
          <PackListPrint
            deliveryDate={deliveryDate}
            loading={pickpackRequesting}
            info={info}
            isPack={isPack}
            isPick={isPick}
            printHeaderChecked={printHeaderChecked}
            checkUpdated={checkUpdated}
          />
        );
        break;
      case FILTER.WAREHOUSE:
        renderData = (
          <WarehouseListPrint
            deliveryDate={deliveryDate}
            loading={false} // TODO: set correct value for loading
            info={info}
            printHeaderChecked={printHeaderChecked}
            checkUpdated={checkUpdated}
          />
        );
        break;
      case FILTER.GROUPED_LIST:
        renderData = (
          <GroupedListPrint
            deliveryDate={deliveryDate}
            loading={requesting}
            packListInfo={info}
            printHeaderChecked={printHeaderChecked}
            checkUpdated={checkUpdated}
          />
        );
        break;
      case FILTER.HARVEST:
        renderData = (
          <HarvestListPrint
            deliveryDate={deliveryDate}
            loading={requesting}
            packListInfo={info}
            printHeaderChecked={printHeaderChecked}
            checkUpdated={checkUpdated}
          />
        );
        break;
      default:
        break;
    }
    return (
      <div>
        {renderData}
      </div>
    );
  }
}

const wrappedDropDownPrint = injectIntl(DropDownPrint);
wrappedDropDownPrint.displayName = 'DropDownPrint';

export default wrappedDropDownPrint;
